import type { ReactNode } from "react";

export type FaqItem = {
	question: string;
	answer: ReactNode;
};

export const defaultFaqItems: FaqItem[] = [
	{
		question: "No que a Flowlab é especialista?",
		answer:
			"Somos especialistas em estratégia, UX/UI design e desenvolvimento de produtos digitais sob medida para empresas que precisam transformar ideias em interfaces claras, eficientes e escaláveis.",
	},
	{
		question: "Por que escolher a Flowlab?",
		answer:
			"Unimos visão de produto, design e tecnologia em um processo direto, colaborativo e orientado a resultado, com entregas pensadas para reduzir risco e acelerar decisões.",
	},
	{
		question: "Quanto custa desenvolver um app ou sistema?",
		answer:
			"Depende muito da complexidade, número de funcionalidades e maturidade do produto. Projetos menores partem de R$ 30.000. Sistemas mais robustos podem chegar a R$ 150.000 ou mais. O melhor caminho é começar pelo nosso Sprint Boost um Discovery de 20 dias que define escopo, reduz riscos e já entrega um direcionamento claro antes de qualquer linha de código.",
	},
	{
		question: "Vocês trabalham junto com o nosso time interno?",
		answer:
			"Sim. Podemos atuar como extensão do seu time, apoiar liderança de produto e tecnologia ou conduzir frentes específicas junto aos stakeholders internos.",
	},
	{
		question: "Vocês ajudam a definir o que construir?",
		answer:
			"Sim. Antes de desenhar ou desenvolver, ajudamos a organizar prioridades, validar caminhos e transformar necessidades de negócio em um plano de produto claro.",
	},
	{
		question: "Vocês continuam dando suporte depois do lançamento?",
		answer:
			"Sim. Depois do lançamento, podemos acompanhar métricas, corrigir pontos críticos, evoluir funcionalidades e apoiar novas fases do produto.",
	},
];
